import { useReducer, useEffect } from "react";
import CadastroAmostraManager from "../CadastroAmostrasManager";

export const useDadosSolicitante = (dadosPedidoPaciente) => {
  const solicitanteVazio = [
    {
      id: "ITEM_VAZIO",
      nome: "",
      numeroConselho: "",
      siglaConselho: "",
      ufConselho: ""
    }
  ];

  const [listaSolicitantes, dispatch] = useReducer((lista, { tipo, valor }) => {
    switch (tipo) {
      case "add":
        return [...lista, valor];
      case "remove":
        return lista.filter(elemento => valor !== elemento.id);
      case "update":
        return [...valor];
      case "reset":
        return solicitanteVazio;
      default:
        return lista;
    }
  }, solicitanteVazio);

  const handleChangeSolicitante = id => event => {
    const index = listaSolicitantes.findIndex(elemento => elemento.id === id);
    listaSolicitantes[index] = event ? event : solicitanteVazio[0];
    dispatch({
      tipo: "update",
      valor: listaSolicitantes
    });
  };

  const deletarSolicitante = id => {
    dispatch({
      tipo: "remove",
      valor: id
    });
  };

  const incluirSolicitante = () => {
    dispatch({
      tipo: "add",
      valor: solicitanteVazio[0]
    });
  };

  const resetSolicitante = () => {
    dispatch({
      tipo: "reset",
      valor: solicitanteVazio
    });
  }

  const inserirSolicitante = solicitante => {
    dispatch({
      tipo: "update",
      valor: [
        {
          id: solicitante.id,
          nome: solicitante.nome.toUpperCase(),
          numeroConselho: solicitante.numeroConselho.toUpperCase(),
          siglaConselho: solicitante.conselho ? solicitante.conselho : solicitante.siglaConselho,
          ufConselho: solicitante.ufConselho
        }
      ]
    });
  };

  useEffect(() => {
    if (
      dadosPedidoPaciente &&
      dadosPedidoPaciente.dadosSolicitantes &&
      dadosPedidoPaciente.dadosSolicitantes.length > 0
    ) {
      dispatch({
        tipo: "update",
        valor: dadosPedidoPaciente.dadosSolicitantes
      });
    }
  }, [dadosPedidoPaciente]);

  const atualizarListaSolicitantes = async (inputValue, uf) => {

    if (inputValue === null || inputValue === "") {
      return [];
    }
    var retorno = await CadastroAmostraManager.listarSolicitantes(inputValue, uf);

    if (!retorno || retorno.erro) {
      return [];
    } else {
      return retorno.lista;
    }
  };

  return {
    value: listaSolicitantes,
    handleChangeSolicitante: handleChangeSolicitante,
    deletarSolicitante: deletarSolicitante,
    incluirSolicitante: incluirSolicitante,
    inserirSolicitante: inserirSolicitante,
    resetSolicitante: resetSolicitante,
    atualizarListaSolicitantes: atualizarListaSolicitantes
  };
};
